import { useQuery } from "@tanstack/react-query";
import leadsAdminService from "services/admin/leadsService";

export const useGetLeads = (queryParams = {}) => {
    console.log('useGetLeads.queryParams', queryParams)
    return useQuery({
        queryKey: ['leads', queryParams],
        queryFn: async () => {
            const response = await leadsAdminService.getLeads(queryParams)
            return response.data
        },
        refetchOnWindowFocus: false,
    })
}